export default "__VITE_ASSET__DYheYktm__"